import { observable, action, toJS } from "mobx";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import BaseStore from "../../common/BaseStore";
import { WBSService } from "modules/WBS/WBSService";
import { ActivitySearchStore } from "modules/activitySearch/ActivitySearchStore";
import { ActivitySearchService } from "modules/activitySearch/ActivitySearchService";
import { CustomPropertyStore } from "modules/customProperties/CustomPropertyStore";
import { ERowType } from "common/enums";
import { times } from "utils/DecimalUtils";

class Store extends BaseStore {
  @observable isProcessing: boolean = false;
  @observable idOldCP: Array<any> = [];
  @observable undoList: Array<any> = [];

  constructor() {
    super("ToolbarTaskStore");
  }

  resetStore() {
    this.isProcessing = false;
    this.undoList = [];
  }

  pasteVerify = () =>
    !(ToolbarStore.WBSCuttedLine || ToolbarStore.WBSCopiedLine);
  moveupVerify = () => {
    if (WBSStore.selectedLine.index === 0) return true;
    return false;
  };
  movedownVerify = () => {
    let { WBSRowsIndex, data } = WBSStore.selectedLine;
    if (WBSStore.WBSRows[WBSRowsIndex] == undefined) return false;
    let index = WBSStore.WBSRows.findIndex(
      (r) =>
        r.data.parentTask == data.parentTask &&
        r.data.rowIndex == data.rowIndex + 1
    );
    if (index == -1) return true;
    return false;
  };

  @action
  async cutTaskRow() {
    let selectedLine = {
      ...WBSStore.WBSRows[WBSStore.selectedLine.WBSRowsIndex],
    };
    ToolbarStore.WBSCopiedLine = {
      row: selectedLine,
      data: WBSStore.recursiveRowGet(selectedLine.id),
    };
    await this.deleteTaskRowAsync();
  }

  //
  @action
  async handelActions(action, params) {
    let { originalOperation, undoOperation, data } = params;

    // Executa a função passada no parametro "action"
    await action;

    // Quando exede o número de ações de desfazer permitira exclui o item que está a mais tempo na lista.[Funcionamento de lista]
    if (this.undoList.length >= 5 && originalOperation !== "undoWBSRow") {
      this.undoList.pop();
    }

    if (originalOperation !== "undoWBSRow") {
      if (data.undoFunction.selectedLine.length > 0) {
        this.undoList.unshift({
          originalOperation: originalOperation,
          undoOperation: undoOperation,
          parameter: {
            undoFunction: {
              ...data.undoFunction,
              selectedLine: data.undoFunction.selectedLine[0],
            },
            originalFunction: data.originalFunction,
          },
        });
      } else {
        this.undoList.unshift({
          originalOperation: originalOperation,
          undoOperation: undoOperation,
          parameter: {
            undoFunction: {
              ...data.undoFunction,
              selectedLine: WBSStore.selectedLine,
            },
            originalFunction: data.originalFunction,
          },
        });
      }
    }
  }

  @action
  async undoWBSRow() {
    // Quando a função de desfazer é acionada elimina o item que está a menos tempo na lista.[Funcionamento de pilha]
    let undo = this.undoList.shift();
    const fn = undo.parameter.undoFunction.function;
    let param = undo.parameter.undoFunction.params;
    const line = undo.parameter.undoFunction.selectedLine;
    await WBSStore.setSelectedLine(line.index);
    // console.log("================================================")
    // console.log("Ação à desfazer ===> ", undo)
    // console.log("================================================")
    switch (fn) {
      case "deleteTaskRow":
        await ToolbarTaskStore.deleteTaskRow();
        break;

      case "moveWBSRow":
        if (param) {
          ToolbarTaskStore.createBlankTaskRow(param[0]);
        } else {
          ToolbarTaskStore.createBlankTaskRow();
        }
        break;

      case "moveTaskRow":
        if (param) {
          ToolbarTaskStore.moveTaskRow(param[0]);
        } else {
          ToolbarTaskStore.moveTaskRow();
        }
        break;

      case "pasteTaskRow":
        const copiedLine = undo.parameter.undoFunction.copiedLine;
        let acoes = new Array();
        if (copiedLine.row.data.rowType === 1) {
          if (
            copiedLine.row.data.rateLibraryCode &&
            copiedLine.row.data.rateLibraryId
          ) {
            const rateLibraryTaskId =
              copiedLine.row.data.rateLibraryId +
              "-T" +
              copiedLine.row.data.rateLibraryCode;
            let taskItem = await ActivitySearchService.getRateLibraryTaskById(
              rateLibraryTaskId
            );
            await ActivitySearchStore.handleSelected(taskItem, "RL");
          } else {
            ToolbarTaskStore.undoPasteTaskRow(copiedLine);
          }
        } else {
          ToolbarTaskStore.undoPasteTaskRow(copiedLine);
        }
        break;

      case "changeSelectedLineCode":
        WBSStore.changeSelectedLineCode(param[0], param[1]);
        break;

      //   case 'applyFormula':
      //     WBSPropertiesStore.applyFormula(param[0], param[1])
      //     if (param[0] === undefined || param[0] === ""){
      //       WBSStore.updateWBSRow(line, line.index, "quantity", param[2])
      //     }
      //     break;

      case "changeSelectedLineCategory":
        WBSStore.changeSelectedLineCategory(param[0]);
        break;

      case "updateTaskRow":
        WBSStore.updateTaskRow(param[0], param[1], param[2]);
        break;

      case "recursiveUpdateOfItemQuantityInTask":
        WBSStore.recursiveUpdateOfItemQuantityInTask(
          param[0],
          param[1],
          param[2]
        );
        break;

      case "recursiveUpdateWBSSubcollection":
        WBSStore.recursiveUpdateWBSSubcollection(param[0], param[1]);
        break;

      case "updateWBSSubcollection":
        WBSStore.updateWBSSubcollection(param[0], param[1], param[2]);
        break;

      //   case 'removeQuantityLinkWithTakeOffItem':
      //     await TakeOffStore.removeQuantityLinkWithTakeOffItem(param[0])
      //     break;

      //   case 'addQuantityFromTakeOffItem':
      //     await TakeOffStore.addQuantityFromTakeOffItem(param[0])
      //     break;

      case "syncCustomProperty":
        await CustomPropertyStore.undoSyncCustomProperty(
          param[0],
          param[1],
          param[2]
        );
        break;

      default:
        break;
    }
  }
  //

  @action
  copyTaskRow(activity?, edit?) {
    if (edit) {
      activity.data.quantity = 1;
      activity.data.total = times(
        activity.data.quantity,
        activity.data.unitCost,
        WBSPropertiesStore.getRules(2)
      );
      activity.data.totalBdi = activity.data.total;
    }

    let selectedLine: any = activity
      ? { ...activity }
      : {
          ...WBSStore.WBSRows.find(
            (r) => r.WBSRowsIndex == WBSStore.selectedLine.WBSRowsIndex
          ),
        };
    ToolbarStore.WBSCopiedLine = {
      row: selectedLine,
      data: WBSStore.recursiveRowGet(selectedLine.id),
    };
  }

  async pasteRecursive(
    row: { data; index },
    data: [],
    first?,
    parentReference?,
    isActivity?
  ) {
    const actions = new Array();
    const indexToSelect = WBSStore.selectedLine.index;
    const idToCompare = first
      ? WBSStore.task.id
      : WBSStore.selectedLine.data.parentTask;
    const parentIndex = WBSStore.WBSRows.findIndex((r) => r.id == idToCompare);
    if (parentIndex == -1) return;

    const parentRow = WBSStore.WBSRows[parentIndex];
    if (first) {
      WBSStore.updateTaskUnitCost(row.data.total);
      // atualiza o total das linhas acima recursivamente
      let newData: any = await WBSStore.recursiveUpdateWBSSubcollection(
        parentRow.data.contentId,
        WBSStore.taskUnitCost,
        ERowType.TASK ? undefined : parentRow.data.total,
        parentRow.id,
        true
      );
      actions.push(...newData);
    }
    // Pega os dados do pai e de seus similares
    const allSameContent = WBSStore.getListByContent(
      first ? parentRow.data.contentId : undefined,
      parentRow.id
    );

    for (let j = 0; j < allSameContent.length; j++) {
      const index = WBSStore.WBSRows.findIndex(
        (r) =>
          allSameContent[j].id == r.data.parentTask &&
          WBSStore.selectedLine.data.rowIndex == r.data.rowIndex
      );
      if (index == -1) continue;

      let selectedLine = WBSStore.WBSRows[index];
      let dataRow = { ...row.data };
      if (first) {
        if (isActivity) {
          // dataRow.quantity = 0;
          dataRow.total = times(
            dataRow.unitCost,
            dataRow.quantity,
            WBSPropertiesStore.getRules(2)
          );
        }
        if (selectedLine.data.rowType != ERowType.BLANK) {
          // Puxa as linhas para baixo
          actions.push(
            ...this.changeRowIndex(
              selectedLine.data.rowIndex,
              allSameContent[j].id
            )
          );
          selectedLine.data.rowIndex = indexToSelect;
        }
        dataRow.rowIndex = selectedLine.data.rowIndex;
      }
      if (first) {
        parentReference = allSameContent[j].id;
      }
      if (dataRow.parentStage) {
        dataRow.parentStage = parentReference;
      } else {
        dataRow.parentTask = parentReference;
      }

      // Linha pai
      let rowRef: any = undefined;
      let contentIdToDelete = "";
      if (selectedLine.data.rowType == ERowType.BLANK) {
        rowRef = WBSStore.WBSRef.collection("rows").doc(selectedLine.id);
        let update = WBSService.removeUndefinedFieldsFromUpdatedRow(
          selectedLine,
          dataRow
        );
        contentIdToDelete = dataRow.contentId ? dataRow.contentId : "";
        actions.push({
          type: "update",
          args: [rowRef, update],
        });
        //
        dataRow.id = selectedLine.id;
        for (var key of Object.keys(update)) {
          if (Object.keys(dataRow).filter((d) => d == key).length == 0) {
            dataRow[key] = undefined;
          }
        }
        // Recalcula o insumo e altera a linha selecionada
        WBSStore.changeAllArray(dataRow, selectedLine, true);
      } else {
        rowRef = WBSStore.WBSRef.collection("rows").doc();
        contentIdToDelete = dataRow.contentId ? dataRow.contentId : "";
        actions.push({
          type: "set",
          args: [rowRef, { ...dataRow }],
        });
        //
        let update = {
          data: { ...dataRow },
          id: rowRef.id,
          WBSRowsIndex: WBSStore.WBSRows.length,
        };
        WBSStore.WBSRows[WBSStore.WBSRows.length] = { ...update };
      }
      if (contentIdToDelete != "") {
        actions.push({
          type: "delete",
          args: [
            WBSStore.WBSRef.collection("resources").doc(contentIdToDelete),
          ],
        });
      }

      let rowRefId = rowRef.id;

      // Linhas subsequentes
      for (let i = 0; i < data.length; i++) {
        let dataRow = JSON.parse(JSON.stringify(data[i]));
        if (dataRow.row.data.parentTask) {
          dataRow.row.data.parentTask = rowRefId;
        } else {
          dataRow.row.data.parentStage = rowRefId;
        }
        rowRef = WBSStore.WBSRef.collection("rows").doc();
        contentIdToDelete = dataRow.row.data.contentId
          ? dataRow.row.data.contentId
          : "";
        if (contentIdToDelete != "") {
          actions.push({
            type: "delete",
            args: [
              WBSStore.WBSRef.collection("resources").doc(contentIdToDelete),
            ],
          });
        }

        actions.push({
          type: "set",
          args: [rowRef, { ...dataRow.row.data }],
        });
        WBSStore.WBSRows[WBSStore.WBSRows.length] = {
          data: { ...dataRow.row.data },
          id: rowRef.id,
          WBSRowsIndex: WBSStore.WBSRows.length,
        };
        for (let i = 0; i < dataRow.data.length; i++) {
          let recursive: any = await this.pasteRecursive(
            dataRow.data[i].row,
            dataRow.data[i].data,
            false,
            rowRef.id,
            false
          );
          actions.push(...recursive);
        }
      }
    }
    if (first) {
      await WBSStore.batchActions(actions, true);
      WBSStore.setSelectedLine(indexToSelect, "description");
    }

    return actions;
  }

  @action
  async pasteTaskRow(isActivity = false) {
    await this.pasteRecursive(
      JSON.parse(JSON.stringify(ToolbarStore.WBSCopiedLine.row)),
      JSON.parse(JSON.stringify(ToolbarStore.WBSCopiedLine.data)),
      true,
      undefined,
      isActivity
    );
    WBSStore.updateResource = true;
  }

  async undoPasteTaskRow(copiedLine, isActivity = false) {
    await this.pasteRecursive(
      JSON.parse(JSON.stringify(copiedLine.row)),
      JSON.parse(JSON.stringify(copiedLine.data)),
      true,
      undefined,
      isActivity
    );
    WBSStore.updateResource = true;
  }

  @action
  async createBlankTaskRow(position = "above", delay = true) {
    WBSStore.loading = true;
    let actions = new Array();
    let selectedLine = WBSStore.selectedLine;
    let rowIndex =
      position === "bellow"
        ? selectedLine.data.rowIndex + 1
        : selectedLine.data.rowIndex;
    let selectedLineIndex =
      position === "bellow" ? selectedLine.index + 1 : selectedLine.index;
    WBSStore.resetSelectedLine();
    let item = WBSStore.WBSRows.findIndex((r) => r.id == WBSStore.task.id);
    if (item == -1) {
      WBSStore.loading = false;
      return;
    }

    let allSameContent = WBSStore.getListByContent(
      WBSStore.WBSRows[item].data.contentId,
      WBSStore.WBSRows[item].id
    );

    for (let j = 0; j < allSameContent.length; j++) {
      let blankRow: any = WBSStore.getBlankRow(rowIndex);
      blankRow.parentTask = allSameContent[j].id;
      let newRowRef = await WBSStore.WBSRef.collection("rows").doc();

      actions.push(...this.changeRowIndex(rowIndex, blankRow.parentTask));
      WBSStore.WBSRows[WBSStore.WBSRows.length] = {
        data: blankRow,
        id: newRowRef.id,
        WBSRowsIndex: WBSStore.WBSRows.length,
      };
      actions.push({
        type: "set",
        args: [newRowRef, blankRow],
      });
    }
    await WBSStore.batchActions(actions, false, () => {
      WBSStore.taskRows = WBSStore.orderListByRowIndex(
        WBSStore.WBSRows.filter((r) => {
          return r.data.parentTask == WBSStore.task.id;
        })
      );
      setTimeout(() => {
        WBSStore.setSelectedLine(selectedLineIndex, "description", true);
        WBSStore.loading = false;
      }, 700);
    });
  }

  changeRowIndex(
    rowIndex,
    parentTask,
    direction = 1,
    newParentTask: any = undefined
  ) {
    let actions = new Array();
    let dt = toJS(WBSStore.WBSRows);
    let parentTaskId = parentTask.id ? parentTask.id : parentTask;
    let filtered = dt.filter(
      (dtRow) =>
        dtRow.data.rowIndex >= rowIndex && dtRow.data.parentTask == parentTaskId
    );

    for (let i = 0; i < filtered.length; i++) {
      let rowTemp = { ...filtered[i] };
      let update: any = { rowIndex: rowTemp.data.rowIndex + direction };
      if (newParentTask != undefined) {
        update.parentTask = newParentTask;
      }
      WBSStore.changeWbsRowsArray(update, rowTemp, false);
      actions.push({
        type: "update",
        args: [WBSStore.WBSRef.collection("rows").doc(rowTemp.id), update],
      });
    }
    return actions;
  }

  @action
  async deleteTaskRow() {
    await this.deleteTaskRowAsync();
    if (!WBSStore.updateResource) {
      WBSStore.updateResource = true;
    }
  }

  private async deleteTaskRowAsync() {
    const actions = new Array();
    const deletedRow = WBSStore.selectedLine;
    const wbsRowsTemp = [...WBSStore.WBSRows];

    // Pega o parent
    const parentTask = wbsRowsTemp.findIndex((r) => r.id == WBSStore.task.id);
    if (parentTask === -1) return;

    // Pega o todas as linhas que tenha o mesmo conteudo que o parent
    const allSameContent = WBSStore.getListByContent(
      wbsRowsTemp[parentTask].data.contentId,
      wbsRowsTemp[parentTask].id
    );

    for (const row of allSameContent) {
      // Pega a linha que vai ser deletada
      const copyRowIndex = wbsRowsTemp.findIndex(
        (r) =>
          r.data.contentId == deletedRow.data.contentId &&
          r.data.rowIndex == deletedRow.data.rowIndex &&
          r.data.parentTask == row.id
      );
      if (copyRowIndex === -1) continue;

      const copyRow = { ...wbsRowsTemp[copyRowIndex] };

      // Puxa as linhas para cima
      actions.push(...this.changeRowIndex(copyRow.data.rowIndex + 1, row, -1));

      // Atualiza o resultado total
      if (copyRow.data && copyRow.data.total) {
        actions.push(
          ...WBSStore.createActionsToUpdateParentRows(
            copyRow.data.parentTask,
            -(copyRow.data.total || 0)
          )
        );
      }

      const lineRef = WBSStore.WBSRef.collection("rows").doc(copyRow.id);
      actions.push({
        type: "delete",
        args: [lineRef],
        arrayChange: () => {
          WBSStore.deleteAllArray(copyRow);
        },
      });

      // Deleta recursivamente as linhas de dentro da task/stage
      if (
        copyRow.data.rowType == ERowType.STAGE ||
        copyRow.data.rowType == ERowType.TASK
      ) {
        actions.push(...WBSStore.recursiveRowDelete(copyRow.id));
      }
    }

    await WBSStore.batchActions(actions, true, () => {
      WBSStore.taskRows = WBSStore.orderListByRowIndex(
        WBSStore.WBSRows.filter((r) => r.data.parentTask == WBSStore.task.id)
      );
      if (WBSStore.taskRows.length != deletedRow.index) {
        WBSStore.setSelectedLine(deletedRow.index, "description");
      } else {
        WBSStore.setSelectedLine(deletedRow.index - 1, "description");
      }
    });
  }

  @action
  async moveTaskRow(to = "up") {
    let selectedLine = { ...WBSStore.selectedLine };
    WBSStore.resetSelectedLine();
    let actions = new Array();
    let newIndex = selectedLine.index + (to === "up" ? -1 : 1);
    let oldDt = WBSStore.taskRows[selectedLine.index];
    let newDt = WBSStore.taskRows[newIndex];

    if (!oldDt || !newDt) return;

    let oldIndexInTask = oldDt.data.rowIndex;
    let newIndexInTask = newDt.data.rowIndex;

    if (
      oldDt.data.rowType == ERowType.BLANK &&
      newDt.data.rowType == ERowType.BLANK
    ) {
      WBSStore.setSelectedLine(newIndex, selectedLine.dataKey);
      return;
    }

    let wbsRowsRef = WBSStore.WBSRef.collection("rows");
    WBSStore.loading = true;

    let item = WBSStore.WBSRows.findIndex((r) => r.id == WBSStore.task.id);
    if (item == -1) {
      WBSStore.loading = false;
      return;
    }

    let allSameContent = WBSStore.getListByContent(
      WBSStore.WBSRows[item].data.contentId,
      WBSStore.WBSRows[item].id
    );

    for (let i = 0; i < allSameContent.length; i++) {
      if (to === "up") {
        actions.push(
          ...this.updatePosition(
            oldIndexInTask,
            allSameContent[i].id,
            newIndexInTask,
            wbsRowsRef
          )
        );
        actions.push(
          ...this.updatePosition(
            newIndexInTask,
            allSameContent[i].id,
            oldIndexInTask,
            wbsRowsRef
          )
        );
      } else {
        actions.push(
          ...this.updatePosition(
            newIndexInTask,
            allSameContent[i].id,
            oldIndexInTask,
            wbsRowsRef
          )
        );
        actions.push(
          ...this.updatePosition(
            oldIndexInTask,
            allSameContent[i].id,
            newIndexInTask,
            wbsRowsRef
          )
        );
      }
    }
    await WBSStore.batchActions(actions, true, () => {
      WBSStore.taskRows = WBSStore.orderListByRowIndex(
        WBSStore.WBSRows.filter((r) => {
          return r.data.parentTask == WBSStore.task.id;
        })
      );
      WBSStore.setSelectedLine(newIndex, selectedLine.dataKey);
      WBSStore.loading = false;
    });
  }

  updatePosition(newIndexInTask, parentTask, oldIndexInTask, wbsRowsRef) {
    let actions = new Array();
    let downLineIndex = WBSStore.WBSRows.findIndex(
      (r) =>
        r.data.rowIndex == newIndexInTask && r.data.parentTask == parentTask
    );
    if (downLineIndex != -1) {
      WBSStore.changeWbsRowsArray(
        { rowIndex: oldIndexInTask },
        WBSStore.WBSRows[downLineIndex],
        false
      );
      actions.push({
        type: "update",
        args: [
          wbsRowsRef.doc(WBSStore.WBSRows[downLineIndex].id),
          { rowIndex: oldIndexInTask },
        ],
      });
    }
    return actions;
  }
}

let ToolbarTaskStore = new Store();

export { ToolbarTaskStore };



// WEBPACK FOOTER //
// ./src/modules/WBS/ToolbarTaskStore.tsx